import { request } from '../utils/request'
import { stringify } from '../utils/index'
export default {
  getbatchtasks: (option) => request('v1/batchtask/getbatchtasks', option), // 导出任务列表
  deletebatchtask: (option) => request('v1/batchtask/deletebatchtask' + stringify(option), option), // 导出任务列表
  downloadidentificationcertsaync: (option) => request('v1/luxurycert/downloadidentificationcertsaync' + stringify(option), option,), //  鉴定意见书证书批量导出

  downloadtaguseinfos: (option) => request('v1/tag/downloadtaguseinfos' + stringify(option), option,), //  鉴定意见书证书批量导出

  downloadappraisalorderasync: (option) => request('v1/appraisalorder/downloadappraisalorderasync', option,), //  委托大货订单数量导出
  downloadimageappraisalfees: (option) => request('v1/imageappraisalorder/downloadimageappraisalfees', option,), //  委托大货订单数量导出

  downloadimageappraisals: (option) => request('v1/imageappraisalorder/downloadimageappraisals', option,), //  委托大货订单数量导出

  downloadappraisalauditlogs: (option) => request('v1/appraisalorder/downloadappraisalauditlogs', option,) //  委托大货订单数量导出
}
